import Cookies from 'js-cookie';

function cookieWarning(){
    if( !Cookies.get('cookieWarning') ){
        const cookieWarningDiv = document.createElement("div");
        cookieWarningDiv.innerHTML = '<div>На сайте используются файлы cookies, а также системы Яндекс.Метрика и подобные сервисы. Продолжая использовать сайт вы даете согласие на работу с этими данными.<br>Подробнее: <a href="/soglasie/" target="_blank">Согласие на обработку персональных данных</a>, <a href="/politika/" target="_blank">Политика конфиденциальности</a>.</div>\n' +
            '<button class="button cookie-warning__btn">Хорошо</button>';
        cookieWarningDiv.classList.add("cookie-warning");
        document.body.appendChild(cookieWarningDiv);

        document.querySelector('.cookie-warning__btn').addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.cookie-warning').style.display = 'none';

            try {
                Cookies.set('cookieWarning', 'true', { expires: 365 });
            } catch (err) {
                console.log(err);
            }
        });
    }
}
export default cookieWarning;